import { AsyncThunk, AsyncThunkConfig, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchByIdFactory } from "./fetchByIdFactory";
import { GET_SYSTEM_INFO, System, SystemsResponse } from "../../Services/Agrisys_GqlDataCaller/SystemCalls/GQLCalls/getSystemCall";

export const fetchSystemInfoByIdThunk = createAsyncThunk(
  `systems/fetchByIds`,
  fetchByIdFactory<SystemsResponse, System>(GET_SYSTEM_INFO, (systemInfoResponse) => systemInfoResponse.data.system.info)
) satisfies AsyncThunk<System[], number[], AsyncThunkConfig> as AsyncThunk<System[], number[], AsyncThunkConfig>